module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0836.fbf65b90.jpg";